export type SoldOutItem = { articleId: number }

export const toSoldOutIds = (response: unknown): number[] => {
  if (!Array.isArray(response)) return []
  return response
    .map((item: SoldOutItem) => item?.articleId)
    .filter((id): id is number => typeof id === 'number')
}
